import { forwardRef } from 'react';

import cn from '@/lib/clsxm';

import Props, { INPUT_TYPES } from '@/components/@base/input/text/type';
import { COLOR_ENUM, SIZE_ENUM } from '@/components/@base/@types';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';

function Input(
  {
    id = '',
    value = '',
    className,
    type = INPUT_TYPES.TEXT,
    size = SIZE_ENUM.MD,
    label,
    Icon,
    LeftIcon,
    stickyText,
    errorState,
    labelClassName,
    LeftIconClass,
    hint,
    placeholder = " ",
    ...other
  }: Props,
  ref: any,
) {
  return (
    <Container>
      <Container className='relative'>
        <Container className='float-label-input relative bg-inherit'>
          {Icon && (
            <Container center className='absolute inset-y-0 right-0 w-8'>
              <Icon />
            </Container>
          )}
          {LeftIcon === undefined && stickyText && (
            <Container center className={cn('absolute top-[50%] -translate-y-1/2 left-4')}>
              <Text className='text-grayLight-1000 dark:text-grayDark-300'>{stickyText}</Text>
            </Container>
          )}
          {LeftIcon && (
            <Container
              center
              className={cn('absolute left-4 top-2/4 -translate-y-2/4', LeftIconClass)}
            >
              <LeftIcon />
            </Container>
          )}
          <input
            placeholder={placeholder}
            className={cn(
              'focus:shadow-outline block w-full focus:border-grayLight focus:dark:border-grayDark-700 appearance-none rounded-lg  border border-grayDark-700  ' +
              'bg-gray-50 p-2.5 px-3 py-3 text-sm  leading-normal text-white outline-none focus:outline-none',
              size === SIZE_ENUM.XXS && 'h-4',
              size === SIZE_ENUM.XS && 'h-6',
              size === SIZE_ENUM.SM && 'h-7',
              size === SIZE_ENUM.MD && 'h-8',
              size === SIZE_ENUM.LG && 'h-10',
              size === SIZE_ENUM.XL && 'h-12',
              size === SIZE_ENUM.XXL && 'h-14',
              Icon && 'pr-8',
              stickyText && 'pl-8',
              className,
              errorState &&
              'border-solid !border-red-200 focus:!border-red-200 !bg-red-200/40 dark:!border-red-300 focus:dark:!border-red-300 dark:!bg-red-300/30 ',
            )}
            ref={ref}
            value={value && value}
            type={type}
            id={id}
            {...other}
          />

          {label && (
            <label
              htmlFor={id}
              className={cn(
                'text-[#99999E] text-sm pointer-events-none absolute right-3 top-2/4 block -translate-y-2/4 px-2 py-0 transition duration-200 ease-in-out bg-white dark:bg-grayDark-900',
                labelClassName,
                errorState && 'text-danger',
              )}
              style={Icon && { fontSize: '80%', top: 0 }}
            >
              {label}
            </label>
          )}
        </Container>
        {/*{errorState && (*/}
        {/*  <Text*/}
        {/*    className='absolute -bottom-7 px-2 leading-7'*/}
        {/*    size={SIZE_ENUM.SM}*/}
        {/*    color={COLOR_ENUM.ERROR}*/}
        {/*  >*/}
        {/*    {errorState}*/}
        {/*  </Text>*/}
        {/*)}*/}
        {!errorState && hint && (
          <Text
            className='absolute -bottom-7 px-2  leading-7'
            color={COLOR_ENUM.XLIGHT_GRAY}
            size={SIZE_ENUM.SM}
          >
            {hint}
          </Text>
        )}
      </Container>
    </Container>
  );

}

export default forwardRef(Input);
